import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { CustomRole, CreateCustomRoleData, UpdateCustomRoleData } from '../types/permission.types';
import {
  GRUPOS_DE_FUNCIONALIDAD,
  gruposDisponibles,
  llavesDeclaradas,
} from '../estructura-de-permisos';
import { techoParaEditarRoles } from '@/features/auth/tenant-modules';

class CustomRoleService {
  async getAll(): Promise<CustomRole[]> {
    return apiClient.get(ENDPOINTS.CUSTOM_ROLES);
  }

  async getById(id: string): Promise<CustomRole> {
    return apiClient.get(ENDPOINTS.CUSTOM_ROLE_BY_ID(id));
  }

  async create(data: CreateCustomRoleData): Promise<CustomRole> {
    return apiClient.post(ENDPOINTS.CUSTOM_ROLES, data);
  }

  async update(id: string, data: UpdateCustomRoleData): Promise<CustomRole> {
    return apiClient.put(ENDPOINTS.CUSTOM_ROLE_BY_ID(id), data);
  }

  /**
   * Copia el rol con TODAS sus filas (funcionales, de menú y candados) a un rol nuevo, sin
   * personas. Sirve para partir un rol compartido por cargos distintos sin remarcar todo.
   */
  async duplicate(id: string, name?: string): Promise<CustomRole> {
    return apiClient.post(ENDPOINTS.CUSTOM_ROLE_DUPLICATE(id), name ? { name } : {});
  }

  async delete(id: string): Promise<void> {
    return apiClient.delete(ENDPOINTS.CUSTOM_ROLE_BY_ID(id));
  }

  async updatePermissions(
    id: string,
    permissions: string[],
    menuItems: string[],
    lockedMenuItems: string[] = []
  ): Promise<CustomRole> {
    return apiClient.put(ENDPOINTS.CUSTOM_ROLE_PERMISSIONS(id), {
      permissions,
      menuItems,
      lockedMenuItems,
      // Sólo lo que la pantalla MOSTRÓ: el servidor conserva el resto (navegador viejo, o un grupo
      // de un módulo que la empresa no tiene y que no se dibujó).
      clavesConocidas: llavesDeclaradas(
        gruposDisponibles(GRUPOS_DE_FUNCIONALIDAD, techoParaEditarRoles())
      ),
    });
  }
}

export const customRoleService = new CustomRoleService();
